import { AnalyticsTypes } from './google-analytics';

export const attachPageCategory = (action, pageName) => {
    if (action.meta && action.meta.analytics) {
        let analyticsArray = [action.meta.analytics];
        if (Array.isArray(action.meta.analytics)) {
            analyticsArray = action.meta.analytics;
        }

        for (let i = 0; i < analyticsArray.length; i++) {
            if (
                analyticsArray[i].type === AnalyticsTypes.TrackEvent &&
                !analyticsArray[i].category
            ) {
                analyticsArray[i].category = pageName;
            }
        }
    }
};

export const pageCategoryMiddleware = (pageName) => {
    return () => (next) => (action) => {
        attachPageCategory(action, pageName);
        return next(action);
    };
};
